import { render, staticRenderFns } from "./GroupSubjectsSubGroup.vue?vue&type=template&id=1d221812&"
import script from "./GroupSubjectsSubGroup.vue?vue&type=script&lang=js&"
export * from "./GroupSubjectsSubGroup.vue?vue&type=script&lang=js&"
import style0 from "./GroupSubjectsSubGroup.vue?vue&type=style&index=0&id=1d221812&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports